$( function( )
{
    var $list            = $( '#page-notifications-list' )
      , $items           = $list.find( 'li' )
      , $moreLoader      = $( '#notifications-more-loader' )
      , $moreButton      = $moreLoader.find( 'a' )
      , pageLimit        = $moreButton.data( 'page-limit' )
      , tabFilter        = '[data-type!=""]'
      , $noNotifications = $list.find( '.no-notifications' );

    //window.common.els.$body.addClass('notification-feed');

    $moreButton.on( 'click', function( e )
    {
        e && e.preventDefault();

        $items.filter( tabFilter + '.hidden:lt(' + pageLimit + ')' ).removeClass( 'hidden' );

        if( !$items.filter( tabFilter + '.hidden' ).size() )
        {
            $( this ).parent().hide();
        }

    } );

    $( '#notifications-page-filters' ).on( 'click', 'a', function( e )
    {
        e && e.preventDefault();

        if( $( this ).parent().hasClass( 'current-tab' ) )
        {
            return;
        }

        $( this ).parent().addClass( 'current-tab' ).siblings().removeClass( 'current-tab' );

        var type = $( this ).data( 'type' );

        if( type == 'all' )
        {
            tabFilter = '[data-type!=""]';

            $items.addClass( 'hidden' ).filter( ':not(.no-notifications):lt(' + pageLimit + ')' ).removeClass( 'hidden' );

            if( $items.filter( tabFilter + '.hidden' ).size() )
            {
                $moreLoader.show();
            }
            else
            {
                $moreLoader.hide();
            }

            return;
        }

        tabFilter = '[data-type="' + type + '"]';

        $items.addClass( 'hidden' );
        $items.filter( tabFilter + ':lt(' + pageLimit + ')' ).removeClass( 'hidden' );

        if( !$items.filter( tabFilter ).size() )
        {
            $noNotifications.removeClass( 'hidden' );
        }

        $moreLoader[ $items.filter( tabFilter + '.hidden' ).size() ? 'show' : 'hide' ]();
    } );
} );
